export default [
    {
        id: 0,
        text: "Belum Di Aprove"
    },
    {
        id: 1,
        text: "Disetujui"
    },
    {
        id: 2,
        text: "Ditolak"
    }
]